import logo from './logo.svg';
import Pages from './pages';
import './App.css';

function App() {
  return (
    <div>
      <Pages/>
    </div>
  );
}

export default App;
